/**
 * Created by Kristy on 7/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('prospectivePatients', {
                parent: 'app',
                url: '/prospectivePatients',
                data: {
                    authorities: ['ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.prospectivePatients.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/prospectivePatients/prospectivePatients.html',
                        controller: 'ProspectivePatientsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('prospectivePatientView', {
                abstract: true,
                parent: 'app',
                url: '/prospectivePatients/search?id:prospectivePatientId',
                data: {
                    authorities: ['ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.prospectivePatients.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/prospectivePatients/prospectivePatientView.html',
                        controller: 'ProspectivePatientViewController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    entity: ['$stateParams', 'ProspectivePatient', function($stateParams, ProspectivePatient) {
                        return ProspectivePatient.get({id : $stateParams.id});
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
